/**
 * Fime – Articles List filter + AJAX (Article List template).
 * Mobile accordion + desktop dropdown panels for the filter UI, and
 * AJAX-driven filtering/"Load more" — no page reload.
 */

// ── Mobile accordion (single-open) ──────────────────────────────────────
const afAccordionItems = document.querySelectorAll('.af-accordion-item');

afAccordionItems.forEach(function (item) {
	const trigger = item.querySelector('.af-accordion-trigger');

	trigger.addEventListener('click', function () {
		const isOpen = item.classList.contains('is-open');

		afAccordionItems.forEach(function (otherItem) {
			otherItem.classList.remove('is-open');
		});

		if (!isOpen) {
			item.classList.add('is-open');
		}
	});
});

// ── Desktop filter dropdowns (single-open, click outside to close) ─────
const filterTriggers = document.querySelectorAll('.article-filter-trigger');

function closeAllFilterPanels() {
	filterTriggers.forEach(function (t) {
		t.setAttribute('aria-expanded', 'false');
		const panel = document.getElementById('filter-panel-' + t.dataset.filter);
		if (panel) panel.classList.add('hidden');
	});
}

filterTriggers.forEach(function (trigger) {
	trigger.addEventListener('click', function (e) {
		e.stopPropagation();
		const panel = document.getElementById('filter-panel-' + trigger.dataset.filter);
		const isOpen = trigger.getAttribute('aria-expanded') === 'true';

		closeAllFilterPanels();

		if (!isOpen && panel) {
			trigger.setAttribute('aria-expanded', 'true');
			panel.classList.remove('hidden');
		}
	});
});

document.addEventListener('click', function (e) {
	if (!e.target.closest('.article-filter-group')) {
		closeAllFilterPanels();
	}
});

// ── AJAX filtering + load more ──────────────────────────────────────────
const articlesSection = document.querySelector('.articles-section');

if (articlesSection) {
	const ajaxUrl = articlesSection.dataset.ajaxUrl;
	const ajaxNonce = articlesSection.dataset.ajaxNonce;
	const gridEl = document.getElementById('articles-grid');
	const featuredWrapper = document.getElementById('articles-featured-wrapper');
	const loadMoreWrapper = document.getElementById('articles-load-more-wrapper');
	const loadMoreBtn = document.getElementById('articles-load-more');
	const clearFiltersBtns = document.querySelectorAll('.article-clear-filters');

	// Desktop + mobile each have their own checkbox for the same
	// taxonomy/value — keep both in sync whenever either changes.
	function syncCheckboxes(taxonomy, value, checked) {
		document
			.querySelectorAll('input[data-taxonomy="' + taxonomy + '"][value="' + value + '"]')
			.forEach(function (cb) {
				cb.checked = checked;
			});
	}

	function getSelected(taxonomy) {
		const seen = new Set();
		document
			.querySelectorAll('input[data-taxonomy="' + taxonomy + '"]:checked')
			.forEach(function (cb) {
				seen.add(cb.value);
			});
		return Array.from(seen);
	}

	function fetchArticles(paged, append) {
		const body = new URLSearchParams();
		body.append('action', 'filter_articles');
		body.append('nonce', ajaxNonce);
		body.append('paged', paged);
		getSelected('industry').forEach(function (v) { body.append('industry[]', v); });
		getSelected('expertise').forEach(function (v) { body.append('expertise[]', v); });
		getSelected('resource').forEach(function (v) { body.append('resource[]', v); });

		fetch(ajaxUrl, { method: 'POST', body: body })
			.then(function (res) { return res.json(); })
			.then(function (json) {
				if (!json.success) return;
				const data = json.data;

				if (append) {
					gridEl.insertAdjacentHTML('beforeend', data.cards_html);
				} else {
					gridEl.innerHTML = data.cards_html;
					featuredWrapper.innerHTML = data.has_featured ? data.featured_html : '';
				}

				loadMoreBtn.dataset.paged = paged;
				loadMoreWrapper.hidden = !data.has_more;
			});
	}

	// Any checkbox change → sync twin (desktop/mobile) → refetch from page 1
	document.querySelectorAll('input[data-taxonomy]').forEach(function (cb) {
		cb.addEventListener('change', function () {
			syncCheckboxes(cb.dataset.taxonomy, cb.value, cb.checked);
			fetchArticles(1, false);
		});
	});

	clearFiltersBtns.forEach(function (btn) {
		btn.addEventListener('click', function () {
			document.querySelectorAll('input[data-taxonomy]').forEach(function (cb) {
				cb.checked = false;
			});
			fetchArticles(1, false);
		});
	});

	loadMoreBtn.addEventListener('click', function () {
		const nextPage = parseInt(loadMoreBtn.dataset.paged, 10) + 1;
		fetchArticles(nextPage, true);
	});

	// ── Pre-select a filter from the URL (e.g. mega menu links like
	// /article-list/?insight_type=news) and apply it on load. ────────
	const urlParams = new URLSearchParams(window.location.search);
	const insightTypeParam = urlParams.get('insight_type');

	if (insightTypeParam) {
		syncCheckboxes('resource', insightTypeParam, true);
		fetchArticles(1, false);
	}
}
